<template>
  <div>
    <el-container>
      <!-------头部部分开始-------------->
      <el-header>
        <div class="left">
          <div class="title_log">
            <img alt="" src="../static/title_logo.png" />
          </div>
        </div>

        <div class="portrait">
          <!-- 中英切换 -->
          <div class="enlish">
             <div class="language" @click="changeLang()">
              <div v-if="lang == 'en'" class="chese">
                CH
              </div>
              <div v-else class="english">
                EN
              </div>
            </div>  
          </div> 

          <div class="menu">
            <img
              src="../static/menu.png"
              alt=""
              v-if="!popupDrawer"
              @click="popupDrawer = true"
            />
            <img
              src="../static/menuIcon/error.png"
              alt=""
              v-else
              @click="popupDrawer = false"
            />
          </div>
        </div>
      </el-header>
      <!----------------------el-header结束---------------------------->
      <!----------------------控制登录退出等操作------------------------>
      <div>
        <el-dialog
          :visible.sync="dialogVisible"
          :title="$t('logout.tip')"
          width="60%"
        >
          <span>{{ $t("logout.sureTip") }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="sure()">{{
              $t("logout.sure")
            }}</el-button>
            <el-button size="small" @click="dialogVisible = false">{{
              $t("logout.cancel")
            }}</el-button>
          </span>
        </el-dialog>
      </div>

      <!-- 菜单弹窗开始 -->
      <div class="menu">
        <el-drawer
          :visible.sync="popupDrawer"
          :with-header="false"
          :size="size"
        >
          <div class="menuItem">
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item
                :name="index"
                v-for="(item, index) in menu"
                :key="index"
                :disabled="fold(item)"
              >
                <template slot="title">
                  <a @click="enterPage(item.path, item.params, item.title)"
                    ><div
                      class="mainTitle"
                      :class="[!item.children ? 'mianBan' : '']"
                    >
                      {{ $t(item.title)}}
                    </div>
                    <div class="dot" v-if="item.path == 'myMessage' && num">
                      <el-badge :is-dot="num"></el-badge>
                    </div>
                  </a>
                </template>
                <div class="submenu" v-if="item.children">
                  <div
                     class="itemMenu"
                      v-for="(i, k) in item.children"
                     :key="k"
                  >
                    <a @click="enterPage(i.path, i.params)">{{ $t(i.title)}}</a>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>

            <!-- 注销按钮 -->
            <div class="exit" @click="exitLogin()">
              <div class="img">
                <i class="el-icon-switch-button"></i>
              </div>
              <div class="txt">{{$t('navbar.logout')}}</div>
            </div>
          </div>
        </el-drawer>
      </div>
      <!-- 菜单弹窗结束 -->

      <div class="bo">
        <router-view @getMessage="showMsg" />
      </div>
    </el-container>
  </div>
</template>

<script>
import { logout } from "../../api/login.js";
import { backFront } from "../../utils/common.js";
import { getLists } from "../../api/message.js"; //接口刷新数据
import  config from '../../config.js';

export default {
  components: {},
  data() {
    return {
      backFront: backFront(),
      open: true,
      dialogVisible: false,
      fullscreen: false,
      defaultActive: "",
      num: false,
      lang: "",
      goFlag: false,
      popupDrawer: false, //打开菜单弹窗
      size: "100vw", //弹框的尺寸
      //菜单列表
      menu: [
        {
          title:'navbar.home',
          path: "homeIndex",
          params: "",
        },
        {
          title:'navbar.PersonalInfo',
          path: "",
          params: "",
          children: [
            {
              title:'navbar.basicInfo',
              path: "personInfo",
              params: "first",
            },
            {
              title:'navbar.letter',
              path: "personInfo",
              params: "second",
            },
            {
             title:'navbar.questionnaire',
              path: "personInfo",
              params: "third",
            },
            {
              title:'navbar.updataPassword',
              path: "personInfo",
              params: "fifth",
            },
          ],
        },
        {
            title:'navbar.publicize',
            path:config.exhibitionList,
            params: "",
        },
        {
         title:'navbar.collecytion',
          path: "",
          params: "",
          children: [
            {
              title:'navbar.collExhibitors',
              path: "collectionInfo",
              params: "first",
            },
            {
               title:'navbar.collProduct',
              path: "collectionInfo",
              params: "second",
            },
            {
              title:'navbar.collLive',
              path: "collectionInfo",
              params: "third",
            },
            {
              title:'navbar.collActive',
              path: "collectionInfo",
              params: "fourth",
            },
          ],
        },
        {
         title:'navbar.MyMessage',
          path: "myMessage",
          params: "",
        },
      ],
      //折叠面板
      activeNames: ["2"],
    };
  },
  methods: {
    goHomepage() {
      this.goFlag = true;
      window.open(backFront());
    },
    changeLang() {
      if (this.lang == "zh") {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        this.lang = "en";
      } else if (this.lang == "en") {
        localStorage.setItem("lang", "zh");
        this.$i18n.locale = "zh";
        this.lang = "zh";
      }
      window.location.reload();
    },
    showMsg(val) {
      this.num = val;
    },
    stateSwitch() {
      this.open = !this.open;
    },
    //退出登录按钮
    sure() {
      sessionStorage.clear(); //清空sessionStorage的存储信息
      this.dialogVisible = !this.dialogVisible; //打开弹框
      this.popupDrawer = false;
      this.$router.push({ name: "adminLogin" });
      localStorage.removeItem("audienceInfo"); //移除登录用户信息
      localStorage.removeItem("viewToken"); //移除观众的token
      localStorage.removeItem("lang"); //移出语言记录
      this.$router.push({ path: "/adminLogin", replace: true }); //跳出到登录页面
      // window.location.href = this.backFront + "?viewFlag";  //跳出到线上展会界面
    },
    async logout() {
      try {
        const { data } = await logout();
        if (data.code == 200) {
          this.dialogVisible = true;
        } else {
          this.$message.error(this.$t("sidebar.error"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    outForm() {
      this.logout();
    },
    //------------------------------
    //折叠面板的方法
    handleChange(val) {
      //  console.log(val);
    },
    //是否可展开
    fold(item) {
      return item.children ? false : true;
    },

    //路由跳转
    enterPage(path, parameter, title) {
      if (path == "") {
        return false;
      }
      if (path == config.exhibitionList) {
        let a = document.createElement("a");
        a.href = path;
        a.click();
      }
      const arr = ["personInfo", "collectionInfo"];
      const address = parameter;
      for (let i in arr) {
        if (arr[i] == path) {
          this.$router.push({
            name: String(path),
            query: { positionId: address },
          });
          this.popupDrawer = false;
          return false;
        }
      }
      this.$router.push({ name: String(path) });
      this.popupDrawer = false;
    },

    //注销登录
    exitLogin() {
      this.dialogVisible = !this.dialogVisible;
      //   this.popupDrawer = false;
      //   console.log("注销登录");
      //   this.$router.push({ name: "adminLogin" });
      //   localStorage.removeItem("audienceInfo"); //移除登录用户信息
      //   localStorage.removeItem("viewToken"); //移除观众的token
      //   localStorage.removeItem("lang"); //移出语言记录
    },

    //获取聊天的记录数量
    async getList() {
      try {
        const { data } = await getLists();
        if (data.code === 200) {
          let count = this.unread(data.data);
          if (count > 0) {
            this.num = true;
          } else {
            this.num = false;
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },

    //记录未读消息数量
    unread(arr) {
      let count = 0;
      arr.forEach((item, index) => {
        if (item.count != 0) {
          count += 1;
        }
      });
      return count;
    },
  },
  created() {
    this.getList(); //获取接口列表,检查是否有消息未读
    const lang = localStorage.getItem("lang");
    this.$i18n.locale = lang ? lang : "zh";
    this.lang = lang ? lang : "zh";
    let i = this.$route.path;
    if (i == "/backIndex/messageDetail") {
      i = "/backIndex/myMessage";
    }
    this.defaultActive = i;
  },
  watch: {
    $route() {
      let i = this.$route.path;
      if (i == "/backIndex/messageDetail") {
        i = "/backIndex/myMessage";
      }
      localStorage.setItem("index", i); //刷新
      setTimeout(() => {
        //路由跳转
        // this.$refs.menu.activeIndex = i;
      }, 100);
    },
    goFlag(newVal, oldVal) {
      if (newVal == true) {
        this.goFlag = false;
      }
    },
  },
};
</script>
<style scoped>
.bo {
  background: #f0f2f5;
}
* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
}
html,
body {
  min-width: 100vw;
}

.el-header {
  width: 100%;
  height: 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("../static/backImg.png");
  box-sizing: border-box;
  z-index: 99999;
  position: fixed;
  top: 0px;
  left: 0px;
}
/* ------------------------------------------- */

.title_log img {
  max-height: 30px;
  margin-left: 15px;
}

.link {
  font-size: 18px;
  font-weight: 500;
  color: #006fb8;
}

.img img {
  height: 62px;
  margin: 0 10px 0 20px;
}

.icon {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.el-menu {
  border: none;
}

.el-menu-item {
  display: flex;
  align-items: center;
}

.el-menu-item:hover {
  background: #e8f6ff;
}

.el-menu-item.is-active {
  background: #e8f6ff !important;
}

.el-main {
  background-color: #f0f2f5;

  color: #333;
}

.el-row >>> .el-col-24 {
  width: 220px;
  background: white !important;
}

.left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: white;
}

.el-header .title {
  font-size: 21px;
  margin-left: 30px;
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 25px;
  margin-right: 50px;
  color: white;
}

.icon1 i {
  margin-right: 30px;
}

.portrait {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.portrait .menu {
  width: 18px;
  height: 12px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 25px;

  box-shadow: 0px 0px 4px 0px rgba(0, 111, 184, 1);
}
.portrait img {
  width: 18px;
  height: 18px;
}

/* ------------------------------------------------------ */

.el-dropdown {
  position: relative;
  top: -2px;
}

.el-dropdown-link {
  cursor: pointer;
  color: white;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.goOnline {
  background: #fff !important;
}
</style>
<style lang="scss" scoped>
.language {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  margin-left: 5px;

  .chese {
    margin-left: 9px;
    margin-right: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 6px;
      width: 24px;
      height: 24px;
    }
  }

  .english {
    margin-left: 9px;
    margin-right: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 6px;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
<style scoped>
.menuItem {
  padding: 0px 15px;
  box-sizing: border-box;
}
.el-menu-item >>> .el-badge__content.is-fixed.is-dot {
  right: -7px;
}

.el-menu-item >>> .el-menu-item * {
  vertical-align: top;
}

.el-menu-item >>> .el-badge {
  display: block !important;
}
</style>
<style scoped lang="scss">
.submenu {
  box-sizing: border-box;
  background: #10669f;
  /* 调节菜单子项的颜色,尺寸等 */
  .itemMenu {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 25px;
    padding: 0px 25px 0px 25px;
    a {
      color: #ffffff;
      line-height: 25px;
      width: 100%;
      display: block;
      padding: 16px 0px;
      width: 100%;
    }
  }
}
.mainTitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
  position: relative;
}
.exit {
  border: 1px solid #98c3e1;
  height: 36px;
  border-radius: 4px;

  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
  .img {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      color: #ffffff;
      font-size: 18px;
    }
  }
  .txt {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin-left: 6px;
    position: relative;
    top: -1px;
  }
}
</style>
<style scoped>
.dialog-footer >>> .el-button--small,
.el-button--small.is-round {
  padding: 5px 10px !important;
  box-sizing: border-box;
}
/* ------------------------------------- */
.menu >>> .el-drawer__body {
  padding-top: 50px;
  background-color: #006fb8;
}
.menu >>> .el-collapse-item__content {
  background: #006fb8;
}
.menu >>> .el-collapse-item__header {
  background: #006fb8;
  border-bottom: 1px solid #98c3e1;
}
.menu >>> .el-collapse-item__content {
  padding-bottom: 0px;
  line-height: 0px;
}
.menu >>> .el-collapse-item__header {
  position: relative;
  color: white;
}
.mianBan {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  left: 0px;
  top: 10px;
  background-color: #006fb8;
}
.menuItem >>> .el-collapse-item__header {
  border-top: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.dot {
  position: absolute;
  left: 68px;
  top: 0px;
}
.menuItem >>> .el-collapse-item__wrap {
  border-bottom: none !important;
  border-top: none !important;
}
.menuItem >>> .el-collapse{
      border-top: none !important;
   
}
</style>
